/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from "react";

import { requestCheckout, requestPortal } from "../../services/userService"

// reactstrap components
// Only the grid is still Argon's. The card and buttons are now the
// brand-auth primitives — see styles/brand-auth.css.
import { Container, Row, Col } from "reactstrap";
import "../../styles/brand-auth.css";
import { useNavigate } from "react-router-dom";
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { useUserAuth } from "../../context/UserContext";
import { useLesson } from "../../hooks/lessonFramework";
import useReveal from "hooks/useReveal";

const Checkout = () => {

  // The card's entrance — see styles/premium.css.
  useReveal();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const mainRef = useRef(null);
  const navigate = useNavigate();
  const { setUser, user, logIn } = useUserAuth();

  // OLD LOGIN
  // const { logIn } = useUserAuth();


  // Framework call example
  const { variable1, variable2, method1, method2 } = useLesson();





  const navigateCheckout = async () => {
    const responseURL = await requestCheckout(user.uid, user.email);

    // No URL when the backend fails or enrollment is closed — assigning
    // undefined would navigate to /undefined and bounce to the home page.
    if (!responseURL) return;

    window.location.href = responseURL;
  }



  const navigateToPortal = async () => {
    const responseURL = await requestPortal();

    window.location.href = responseURL;
  }


  // OLD LOGIN. 
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   try {
  //     const responseUser = await loginUser(email, password);
  //     setUser(responseUser)
  //     navigate("/home");
  //   } catch (error) {
  //     setError(error.message);
  //   }
  // };

  return (
    <>
      <DemoNavbar />
      <main className="cn-auth" ref={mainRef}>
        <section className="cn-auth-hero cn-grid">
          <span className="cn-grain" aria-hidden="true" />
          <span className="cn-orb cn-orb-1" />
          <span className="cn-orb cn-orb-2" />
          <span className="cn-orb cn-orb-3" />
          <Container>
            <Row className="justify-content-center">
              <Col xs="12" md="10" lg="6" xl="5">
                <div className="cn-card" data-reveal>
                  <div className="cn-card-head">
                    <h1 className="cn-title">Checkout</h1>
                  </div>

                  {/* Dropped, not moved: a Github/Google sign-in block and a
                      "Forgot password? / Create new account" link row, all four
                      of which were Creative Tim placeholders pointing at
                      href="#pablo" with preventDefault — nothing happened when
                      you clicked any of them. The two buttons below are the only
                      controls on this page that ever did anything. */}
                  <button
                    className="cn-btn-primary cn-btn-block cn-btn-arrow mb-3"
                    type="button"
                    onClick={navigateCheckout}
                  >
                    Checkout
                  </button>
                  <button
                    className="cn-btn-ghost cn-btn-block"
                    type="button"
                    onClick={navigateToPortal}
                  >
                    Portal
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <MainFooter />
    </>
  );
};

export default Checkout;
